import { render, staticRenderFns } from "./AnnualDeclaration.vue?vue&type=template&id=6d2d57ac&scoped=true"
import script from "./AnnualDeclaration.vue?vue&type=script&lang=js"
export * from "./AnnualDeclaration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2d57ac",
  null
  
)

export default component.exports